// contexts/controleBar/mesas/MesaReservaContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchData, postData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';

const MesaReservaContext = createContext();

export const useMesaReserva = () => useContext(MesaReservaContext);

export const MesaReservaProvider = ({ children }) => {
  const [reservas, setReservas] = useState([]);
  const [reservaSel, setResevaSel] = useState({id: 0,
          clienteId: 0,          
          clienteNome:"",
          dataHora:null
          //cliente: { id: 3, nome: "" },
          });

  const { showAlert } = useAlert();
  const { showMessage } = useMessage();

  const fetchReservas = useCallback(async () => {
    try {
      const result = await fetchData('/MesaReserva');
      setReservas(result);
    } catch (error) {
      console.error('Erro ao buscar reservas:', error);
      showMessage(`Erro ao buscar reservas! ${error?.message || error}`, 'danger');
    }
  }, []);

  const addReserva = async (reserva) => {
    try {
      const result = await postData('/MesaReserva', reserva);
      setReservas((prev) => [...prev, result]);
      showAlert('Reserva adicionada com sucesso!');
    } catch (error) {
      console.error('Erro ao adicionar reserva:', error);
      showMessage(`Erro ao adicionar reserva! ${error}`, 'danger');
    }
  };

  const deleteReserva = async (id) => {
    try {
      await deleteData('/MesaReserva', { reservaId: id });
      setReservas((prev) => prev.filter((r) => r.id !== id));
      showAlert('Reserva excluída com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir reserva:', error);
      showAlert('Erro ao excluir reserva!', 'danger');
    }
  };

  return (
    <MesaReservaContext.Provider value={{ reservas, reservaSel, setResevaSel, fetchReservas, addReserva, deleteReserva }}>
      {children}
    </MesaReservaContext.Provider>
  );
};
